import { Patient, Specimen } from '@medplum/fhirtypes';
import { TFunction } from 'i18next';
import { getPatientOrPractitionerName } from '../utils/common-helpers';
import {
  SPECIMEN_STATUS_I18N_KEYS,
  SPECIMEN_CONDITION_I18N_KEYS,
} from '../constants/specimen.consts';

export function getPatientName(
  specimen: Specimen,
  patientId: string | undefined,
  patient: Patient | undefined,
  patients: Map<string, Patient>,
  t: TFunction<'lims'>
): string {
  if (patientId && patient) {
    return getPatientOrPractitionerName(patient);
  }

  const patientIdFromSpecimen = specimen.subject?.reference?.replace(
    'Patient/',
    ''
  );
  if (!patientIdFromSpecimen) {
    return t('specimen.statuses.unknown', 'Unknown', { ns: 'lims' });
  }

  const patientFromMap = patients.get(patientIdFromSpecimen);
  if (!patientFromMap) {
    return t('specimensPage.loading', 'Loading...', { ns: 'lims' });
  }

  return getPatientOrPractitionerName(patientFromMap);
}

export function getSpecimenId(specimen: Specimen): string {
  return specimen.identifier?.[0]?.value || specimen.id || 'N/A';
}

export function getSpecimenType(
  specimen: Specimen,
  t: TFunction<'lims'>
): string {
  const coding = specimen.type?.coding?.[0];
  if (!coding?.code) {
    return t('specimensPage.unknownType', 'Unknown Type', { ns: 'lims' });
  }
  return coding.display || coding.code;
}

export function getStatusName(
  status: string | undefined,
  t: TFunction<'lims'>
): string {
  if (!status) {
    return 'N/A';
  }
  const key = SPECIMEN_STATUS_I18N_KEYS[status];
  return key ? t(key, status) : status;
}

export function getQualityName(
  specimen: Specimen,
  t: TFunction<'lims'>
): string {
  const conditionCode = specimen.condition?.[0]?.coding?.[0]?.code;
  if (!conditionCode) {
    return t('specimensPage.noQuality', 'No quality', { ns: 'lims' });
  }

  const key = SPECIMEN_CONDITION_I18N_KEYS[conditionCode];
  return key ? t(key, conditionCode) : conditionCode;
}

export function getQualityCode(specimen: Specimen): string {
  return specimen.condition?.[0]?.coding?.[0]?.code || 'no-quality';
}
